import React from "react";
import { formatReactionCount } from "../helpers/NumberFormats";

interface ListEngagementSummary {
  reactionCount: number;
  engagementScore: number;
  listVotes: number;
  listItemVotes: number;
  comments: number;
}

interface ListEngagementProps {
  engagement: ListEngagementSummary;
  className?: string;
  showDetails?: boolean;
}

/**
 * Component to display list engagement/reaction count
 */
const ListEngagement: React.FC<ListEngagementProps> = ({
  engagement,
  className = "",
  showDetails = false,
}) => {
  const { reactionCount, listVotes, listItemVotes, comments } = engagement;

  if (reactionCount === 0) {
    return null;
  }

  const formattedReactionCount = formatReactionCount(reactionCount);

  return (
    <div className={`flex list-engagement ${className}`}>
      <span className="reaction-count items-center">
        {formattedReactionCount}
      </span>

      {showDetails && (
        <div className="engagement-details text-xs mt-1">
          <span className="mr-3">👍 {listVotes} votes</span>
          <span className="mr-3">📊 {listItemVotes} rankings</span>
          <span>💬 {comments} comments</span>
        </div>
      )}
    </div>
  );
};

export default ListEngagement;
